import React from "react";
import { Navigate } from "react-router-dom";
import { useLocalStorage } from '../../utils/storage';

const PrivateRoute = ({ children }) => {
    return useLocalStorage('token') ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
